import React from 'react';
import styled from 'styled-components';

function hideWhenEmpty(WrappedComponent) {
  return function ({ children }) {
    if (!children) {
      return null;
    }

    return <WrappedComponent dangerouslySetInnerHTML={{ __html: children }} />;
  };
}

const Title = hideWhenEmpty(styled.h1.attrs(() => ({
  className: 'GiftBox-Title',
}))`
  font-size: 1.4rem;
  line-height: 1.1;
  text-align: center;
  margin-bottom: 10px;
  font-weight: 600;
  color: #444444;
`);

const Subtitle = hideWhenEmpty(styled.h2.attrs(() => ({
  className: 'GiftBox-Subtitle',
}))`
  font-size: 14px;
  text-align: center;
  font-weight: normal;
  margin-bottom: 10px;
  color: rgba(112, 112, 112, 0.75);
`);

const Wrapper = styled.div`
  margin-top: 10px;
  padding-bottom: 9px;
`;

export default ({ title, subtitle, children }) => {
  if (!title && !subtitle) {
    return null;
  }
  return (
    <Wrapper className="GiftBox-Header">
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
      {children}
    </Wrapper>
  );
};
